module.exports = __webpack_public_path__ + "img/instagram.dcaf94af.svg";